import { z } from 'zod';

import { ZodTrimmedString } from '@Common/types/zod/zod-trimmed-string';

export const EmployeeStatusValues = ['current', 'past', 'retired'] as const;
export const ZodEmployeeStatus = z.enum(EmployeeStatusValues);
export type EmployeeStatus = z.infer<typeof ZodEmployeeStatus>;

export const LeavingReasonValues = [
  'decease',
  'job_transfer',
  'retirement',
  'work_ended',
  'other',
] as const;
export const ZodLeavingReason = z.enum(LeavingReasonValues);
export type EmployeeLeavingReason = z.infer<typeof ZodLeavingReason>;

export const ZodSocialStatus = z.enum(['TS', 'TNS'], {
  error: (issue) => {
    // can only be one issue with issue.code = 'invalid_value'
    const values = issue.values.map((value) => `'${String(value)}'`).join(' | ');

    return `Expected ${values}, received ${String(issue.input)}`;
  },
});
export type EmployeeSocialStatus = z.infer<typeof ZodSocialStatus>;

export const ZodEmployeeTaxNumber = ZodTrimmedString.regex(/^\d+$/).length(13).nullable();
